import { request } from "@/interface/helper";

const str = "inoProject";

export const inoProject = {
  [`${str}`]: {
    getList: (data) => request({ data, method: "get", url: "/ino/project/list" }),
    add: (data) => request({ data, method: "post", url: "/ino/project/add" }),
    detail: (data) => request({ data, method: "post", url: "/ino/project/detail" }),
    edit: (data) => request({ data, method: "post", url: "/ino/project/modify" }),
    transfer: data => request({ data, method: "get", url: "/ido/station/transfer" }),
  },
};
